'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _getChartOptions = require('../../../rules/src/chart/getChartOptions');
var _utils = require('../utils');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
exports.default = function (options, data, type, theme, timeFormats, locale) {
  var axisFontOptions = R.pipe((0, _utils.getFontFromTheme)(['axis']), _utils.getOptionsFromFont)(theme);
  var annotationFontOptions = R.pipe((0, _utils.getFontFromTheme)(['annotation']), _utils.getOptionsFromFont)(theme);
  var tooltipFonts = {
    primary: (0, _utils.getFontFromTheme)(['tooltip', 'primary'])(theme),
    secondary: (0, _utils.getFontFromTheme)(['tooltip', 'secondary'])(theme)
  };
  var optionsWithFonts = R.evolve({
    axis: R.pipe(R.over(R.lensPath(['x', 'font']), R.pipe(R.when(R.isNil, R.always({})), R.mergeRight(axisFontOptions))), R.over(R.lensPath(['y', 'font']), R.pipe(R.when(R.isNil, R.always({})), R.mergeRight(axisFontOptions)))),
    serie: R.over(R.lensPath(['annotation', 'font']), R.pipe(R.when(R.isNil, R.always({})), R.mergeRight(annotationFontOptions)))
  })(options);
  return (0, _getChartOptions.getChartOptions)(data, type, optionsWithFonts, tooltipFonts, timeFormats, locale);
};